export default "__VITE_ASSET__C65XfhDl__"